import { render, staticRenderFns } from "./FollowUpSettingForm.vue?vue&type=template&id=c559524e&"
import script from "./FollowUpSettingForm.vue?vue&type=script&lang=js&"
export * from "./FollowUpSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports